import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const Home = r => require.ensure([], () => r(require('../../src/pages/Home')), 'Home')

export default new Router({
  mode: 'history',
  // 解决vue框架页面跳转有白色不可追踪色块的bug
  scrollBehavior(to, from, savedPosition) {
      return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', name: 'HomeLink', component: Home, meta: { index: 5, keepAlive: true } },

    {path: '*', redirect(to){
        console.log(to)
        return '/error'
    }}

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js